/**
 * Drag ids on the block editor CANVAS (the live page). They share one `DndContext` with the Add
 * panel's tiles and column chips, so each kind has its own prefix:
 *
 *   `canvas-el:<fieldId>`      an element (draggable by its tab handle, and a drop target)
 *   `canvas-sec:<sectionId>`   a section (draggable by its "Section" tab, and a drop target)
 *   `canvas:col:<id>:<n>`      a column (`canvasColumnDropId`, the only target an empty column has)
 *
 * `canvasDragToTreeId` maps each to the Sections panel id `applyTreeDrop` already understands, so a
 * canvas drop and a tree drop are the same edit.
 */
const ELEMENT_PREFIX = 'canvas-el:';
const SECTION_PREFIX = 'canvas-sec:';
const COLUMN_PREFIX = 'canvas:col:';

export const canvasElementDragId = (fieldId: string): string => `${ELEMENT_PREFIX}${fieldId}`;
export const canvasSectionDragId = (sectionId: string): string => `${SECTION_PREFIX}${sectionId}`;

export const isCanvasElementDragId = (id: string): boolean => id.startsWith(ELEMENT_PREFIX);
export const isCanvasSectionDragId = (id: string): boolean => id.startsWith(SECTION_PREFIX);
export const isCanvasColumnDropId = (id: string): boolean => id.startsWith(COLUMN_PREFIX);

/** The Sections panel id behind a canvas id; null for anything that is not a canvas id. */
export function canvasDragToTreeId(id: string): string | null {
  if (isCanvasElementDragId(id)) return id.slice(ELEMENT_PREFIX.length);
  if (isCanvasSectionDragId(id)) return `section:${id.slice(SECTION_PREFIX.length)}`;
  if (isCanvasColumnDropId(id)) return id.slice('canvas:'.length);
  return null;
}
